import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
import styled from 'styled-components';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import draftToHtml from 'draftjs-to-html';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Papa from 'papaparse';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import { Editor } from 'react-draft-wysiwyg';
import Toggle from 'react-toggle';
import convertFromRaw from 'draft-js/lib/convertFromRawToDraftState';
import convertToRaw from 'draft-js/lib/convertFromDraftStateToRaw';
import EditorState from 'draft-js/lib/EditorState';
import convertFromHTML from 'draft-js/lib/convertFromHTMLToContentBlocks';
import ContentState from 'draft-js/lib/ContentState';
import { minLengthValidator, emailValidator } from '../../../../helpers/validators';
import { inviteListeners } from '../../../../helpers/invite_listeners';
import ValidatedInput from '../../../../components/inputs/validatedInput';
import Loading from '../../../../components/Loading';
import Colors from '../../../../styles/colors';
import commonStyles from '../../../../styles/commonStyles';
import { DraftEditorWrapper, ToggleLabel, ToggleWrapper } from '../../../../styles/styled';
import CustomDialog from '../custom_dialog';
import { soundcastManager } from '../../../../helpers/managers';
import { invitationBodyTemplate } from '../../../../../server/scripts/helpers/emailTemplate';
import {
  getUsageCurrent,
  getUsageLimit,
  canUserAccessFeature,
} from '../../../../helpers/userinfoHelper';
const { replaceSpecialTags } = require('../../../../../server/scripts/utils.js')();

class InviteSubscribersModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inviteeList: '',
      subject: '',
      invitation: EditorState.createEmpty(),
      enableInvitationEmail: true,
      savingTemplate: false,
      savingListeners: false,
      error: '',
      privateSoundcastsUsageLimit: null,
      privateSoundcastsUsageCount: null,
      isPrivateLimited: false,
    };

    this.closeModal = this.closeModal.bind(this);
    this.setFileName = this.setFileName.bind(this);
    this.onInviteeAdded = this.onInviteeAdded.bind(this);
    this.inviteListeners = this.inviteListeners.bind(this);
    this.onInvitationSubjectChange = this.onInvitationSubjectChange.bind(this);
    this.onInvitationContentChange = this.onInvitationContentChange.bind(this);
    this.onSaveInvitationTemplate = this.onSaveInvitationTemplate.bind(this);
    this.onChangInvitationEmailToggle = this.onChangInvitationEmailToggle.bind(this);
  }

  componentDidMount() {
    this.assignInvitationTemplate();
  }  

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.soundcast, nextProps.soundcast)) {
      this.assignInvitationTemplate(nextProps);
    }
  }

  assignInvitationTemplate(props = {}) {
    props = !isEmpty(props) ? props : this.props;
    const { userInfo = {}, soundcast = {} } = props;

    if (isEmpty(userInfo) || isEmpty(soundcast)) {
      return;
    }

    const { publisher = {} } = userInfo;
    const {
      title: soundcastTitle,
      invitationSubject = '',
      invitationEmail = '',
      enableInvitationEmail = true,
    } = soundcast;

    const subject = isEmpty(invitationSubject)
      ? `You now have access to ${soundcastTitle}`
      : invitationSubject;

    const defaultInvitationTemplate = invitationBodyTemplate({
      publisher,
      soundcast,
    });

    const state = convertFromHTML(defaultInvitationTemplate);
    let contentState = ContentState.createFromBlockArray(state.contentBlocks, state.entityMap);
    let invitation = EditorState.createWithContent(contentState);

    if (!isEmpty(invitationEmail)) {
      contentState = convertFromRaw(JSON.parse(invitationEmail));
      if (!this.isContentStateEmpty(contentState)) {
        invitation = EditorState.createWithContent(contentState);
      }
    }

    let error = '';
    let privateSoundcastsUsageLimit = null;
    let privateSoundcastsUsageCount = null;
    let isPrivateLimited = false;

    const isPrivate = soundcast.published && !soundcast.landingPage;
    if (isPrivate && canUserAccessFeature('SOUNDCAST_PRIVATE')) {
      const limit = getUsageLimit('ALLOWED_SOUNDCAST_PRIVATE_SUBSCRIBERS');
      if (limit && limit < Number.MAX_VALUE) {
        const count = getUsageCurrent('private_subscribers');
        privateSoundcastsUsageLimit = limit;
        privateSoundcastsUsageCount = count;
        isPrivateLimited = true;

        if (count >= limit) {
          error =
            `Unable to send Invitation:` +
            ` You have ${limit} private soundcast subscribers limit within ${userInfo.publisher.plan} plan.` +
            ` There are ${limit - count} subscribers left to add.`;
        } else {
          error =
            `WARNING:` +
            ` You have ${limit} private soundcast subscribers limit within ${userInfo.publisher.plan} plan.` +
            ` There are ${limit - count} subscribers left to add.`;
        }
      }
    }

    this.setState({
      error,
      subject,
      invitation,
      enableInvitationEmail,
      privateSoundcastsUsageLimit,
      privateSoundcastsUsageCount,
      isPrivateLimited,
    });
  }

  isContentStateEmpty(contentState) {
    const isEditorEmpty = !contentState.hasText();
    const currentPlainText = contentState.getPlainText();
    return isEditorEmpty || isEmpty(currentPlainText);
  }

  getInvitationSubject() {
    const {
      soundcast,
      userInfo: { publisher },
    } = this.props;
    const { subject } = this.state;

    return replaceSpecialTags(subject, {
      publisher,
      soundcast,
    });
  }

  getInvitationDraftContent(raw = false) {
    const { invitation } = this.state;
    const content = invitation.getCurrentContent();
    if (raw) {
      return convertToRaw(content);
    }

    return content;
  }

  async inviteListeners() {
    const { soundcast, userInfo, onIncreasePrivateSubscribers, onEndInviteListeners } = this.props;
    const { id: soundcastId } = soundcast;
    const {
      inviteeList,
      enableInvitationEmail,
      privateSoundcastsUsageLimit,
      privateSoundcastsUsageCount,
      isPrivateLimited,
    } = this.state;
    const inviteeArr = inviteeList.split(/[\s,;\n]+/).filter(emailValidator);

    // send email invitations to invited listeners
    const subject = this.getInvitationSubject();
    const rawContent = this.getInvitationDraftContent(true);
    const isContentEmpty = this.isContentStateEmpty(convertFromRaw(rawContent));
    if (isEmpty(inviteeArr) || isEmpty(subject) || isContentEmpty) {
      return this.setState({
        error: 'Unable to send Invitation. The required fields are empty.',
      });
    }

    if (isPrivateLimited) {
      const limit = privateSoundcastsUsageLimit;
      const count = privateSoundcastsUsageCount;
      if (count >= limit) {
        return this.setState({
          error:
            `Unable to send Invitation:` +
            ` You have ${limit} private soundcast subscribers limit within ${userInfo.publisher.plan} plan.` +
            ` There are ${limit - count} subscribers left to add.`,
        });
      } else {
        const newCount = count + inviteeArr.length;
        if (newCount > limit) {
          return this.setState({
            error:
              `Unable to send Invitation:` +
              ` You have ${limit} private soundcast subscribers limit within ${userInfo.publisher.plan} plan.` +
              ` There are ${limit - count} subscribers left to add.` +
              ` But you are trying to add ${inviteeArr.length} more subscribers.`,
          });
        }
      }
    }

    try {
      // only send invitation notif when enabled
      if (enableInvitationEmail) {
        const { publisher = {} } = userInfo || {};
        const htmlContent = draftToHtml(rawContent);
        const content = replaceSpecialTags(htmlContent, {
          soundcast,
          publisher,
        });
        inviteListeners(
          inviteeArr,
          subject,
          content,
          publisher.id,
          publisher.name,
          publisher.imageUrl,
          publisher.email
        ); // use transactional email for this
      }

      // save to firebase
      this.onSaveInvitationTemplate(true);

      // update soundcast
      await soundcastManager.update(soundcastId, { enableInvitationEmail });

      // invitiate api/invite endpoint
      await Axios.post('/api/invite', {
        soundcastId,
        inviteeArr,
      });

      if (isPrivateLimited) {
        inviteeArr.forEach(() => onIncreasePrivateSubscribers());
      }

      this.alertDialog.showModal({
        content: 'Access has been granted.',
        onClose: onEndInviteListeners,
      });
    } catch (err) {
      console.error('Granting access error', err);
      this.alertDialog.showModal({
        content: 'There was a problem granting access, please try again.',
      });
    }
  }

  closeModal() {
    this.setState({
      inviteeList: '',
    });

    this.props.onClose();
  }

  onInviteeAdded(e) {
    const input = e.target.value;
    this.setState({
      error: '',
      inviteeList: input || '',
    });
  }

  onInvitationSubjectChange(e) {
    const input = e.target.value;
    this.setState({
      error: '',
      subject: input || '',
    });
  }

  onInvitationContentChange(editorState) {
    this.setState({
      error: '',
      invitation: editorState,
    });
  }

  onSaveInvitationTemplate(silent = false) {
    const { soundcast } = this.props;
    const { subject: invitationSubject, enableInvitationEmail } = this.state;

    this.setState({ savingTemplate: true }, async () => {
      const invitationEmail = JSON.stringify(this.getInvitationDraftContent(true));
      await soundcastManager.update(soundcast.id, {
        invitationSubject,
        invitationEmail,
        enableInvitationEmail,
      });

      // put some delay, to make it believable
      setTimeout(() => {
        this.setState({ savingTemplate: false }, () => {
          if (!silent) {
            this.alertDialog.showModal({
              content: 'Notificationm message has been successfully saved!',
            });
          }
        });
      }, 700);
    });
  }

  onInviteListeners() {
    this.setState({ savingListeners: true }, async () => {
      // put some delay, to make it believable
      setTimeout(async () => {
        await this.inviteListeners();
        this.setState({ savingListeners: false });
      }, 700);
    });
  }

  onChangInvitationEmailToggle() {
    this.setState(({ enableInvitationEmail }) => {
      return {
        enableInvitationEmail: !enableInvitationEmail,
      };
    });
  }

  setFileName(e) {
    const emailList = [];
    if (e.target.value) {
      const file = document.getElementById('upload_csv').files[0];
      if (file.name.slice(-3) == 'csv') {
        Papa.parse(file, {
          complete: results => {
            if (results.data) {
              let targetCol = prompt(
                'Which column is the emails stored in? (Enter the column number)'
              );

              if (Number.isInteger(Number(targetCol)) && Number(targetCol) > 0) {
                results.data.forEach(row => {
                  let email = row[targetCol - 1] ? row[targetCol - 1] : '';
                  if (email.indexOf('@') > 0) {
                    email = email.toLowerCase().trim();
                    emailList.push(email);
                  }
                });

                this.setState({
                  inviteeList: emailList.join(','),
                });
              } else {
                this.alertDialog.showModal({
                  content: 'Please enter a valid column number.',
                });
              }
            }
          },
        });
      } else {
        this.alertDialog.showModal({
          content: 'Please upload a valid csv file.',
        });
      }
    }
  }

  renderNotificationToggleBtn() {
    const { enableInvitationEmail } = this.state;
    const toggleText = enableInvitationEmail
      ? 'Send notification email to invitees'
      : "Don't send notification email to invitees";

    return (
      <ToggleWrapper>
        <Toggle
          className="toggle-green"
          aria-labelledby="toggle notification"
          checked={enableInvitationEmail}
          onChange={this.onChangInvitationEmailToggle}
        />
        <ToggleLabel className="text-large">{toggleText}</ToggleLabel>
      </ToggleWrapper>
    );
  }

  actionLoading(message = '') {
    return (
      <Loading
        text={message}
        type="circle"
        align="left"
        size={20}
        fontSize={1.4}
        color="#929292"
        fill="#929292"
      />
    );
  }

  render() {
    const { inviteeList, subject, invitation, savingTemplate, savingListeners, error } = this.state;
    const { soundcast, isShown } = this.props;
    if (!isShown) {
      return null;
    }

    return (
      <MuiThemeProvider>
        <React.Fragment>
          <Dialog
            title={`Give access to ${soundcast.title}`}
            actions={[
              <DialogActions>
                <div className="actions">
                  {!(savingTemplate || savingListeners) && (
                    <div className="actions">
                      <FlatButton
                        labelStyle={{ color: '#00BCD4' }}
                        label="Save Template"
                        onClick={() => this.onSaveInvitationTemplate()}
                        disabled={savingTemplate}
                      />
                      <FlatButton
                        label="Close"
                        onClick={this.closeModal}
                        disabled={savingTemplate || savingListeners}
                      />
                      <FlatButton
                        label="Submit"
                        labelStyle={{ color: Colors.mainOrange }}
                        onClick={() => this.onInviteListeners()}
                        disabled={savingTemplate || savingListeners}
                      />
                    </div>
                  )}
                  {(savingTemplate || savingListeners) &&
                    this.actionLoading(savingTemplate ? 'SAVING TEMPLATE' : 'SAVING LISTENERS')}
                </div>
              </DialogActions>,
            ]}
            modal={false}
            open={isShown}
            contentStyle={{
              width: '95%',
              maxWidth: 980,
              height: 700,
              maxHeight: 'none',
            }}
            bodyStyle={{ paddingTop: '2%' }}
            autoScrollBodyContent={true}>
            {!isEmpty(error) && (
              <div className="row">
                <div className="col-lg-12 col-md-12 col-xs-12">
                  <div className="alert alert-danger text-medium" role="alert">
                    {error}
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-md-12">
                <InviteeList
                  placeholder={'Enter listener email addresses, separated by commas'}
                  disabled={savingListeners}
                  onChange={this.onInviteeAdded}
                  value={inviteeList}
                />
                <InviteeUploadSection>
                  <input
                    type="file"
                    name="upload"
                    id="upload_csv"
                    disabled={savingListeners}
                    onChange={this.setFileName}
                    style={styles.inputFileHidden}
                  />

                  <span className="or-text text-medium font-weight-600 xs-display-none">OR</span>
                  <button
                    className="btn text-medium xs-width-100"
                    disabled={savingListeners}
                    onClick={() => {
                      document.getElementById('upload_csv').click();
                    }}>
                    <span>Upload invitee email list in CSV file</span>
                  </button>
                </InviteeUploadSection>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 padding-five-top xs-padding-ten-top">
                <div>
                  <span className="text-extra-large font-weight-600">Notification Subject</span>
                  <div className="padding-one-top">
                    <ValidatedInput
                      className="text-medium"
                      placeholder="Subject"
                      value={subject}
                      validators={[minLengthValidator.bind(null, 1)]}
                      styles={styles.inputText}
                      disabled={savingTemplate || savingListeners}
                      onChange={this.onInvitationSubjectChange}
                    />
                  </div>
                </div>
                <div>
                  <span className="text-extra-large font-weight-600">Notification Message</span>
                  <div className="padding-one-top margin-bottom-20px">
                    <DraftEditorWrapper>
                      <Editor
                        editorState={invitation}
                        editorStyle={styles.editorStyle}
                        onEditorStateChange={this.onInvitationContentChange}
                        stripPastedStyles={true}
                      />
                    </DraftEditorWrapper>
                  </div>
                  {this.renderNotificationToggleBtn()}
                </div>
              </div>
            </div>
          </Dialog>
          <CustomDialog ref={ref => (this.alertDialog = ref)} />
        </React.Fragment>
      </MuiThemeProvider>
    );
  }
}

const InviteeList = styled.textarea`
  padding: 10px;
  font-size: 1.6rem;
  border-radius: 4px;
  resize: vertical;
  max-height: 200px;
  min-height: 45px;
  margin: 0;
`;

const InviteeUploadSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  .or-text {
    margin: 0 10px;
  }

  button {
    padding: 8px 20px;
  }
`;

const DialogActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  .actions {
    display: flex;
    flex-direction: row;
  }
`;

const styles = {
  inputFileHidden: { ...commonStyles.inputFileHidden },
  editorStyle: {
    padding: '5px 10px',
    fontSize: 16,
    borderRadius: 4,
    height: '250px',
    width: '100%',
    backgroundColor: Colors.mainWhite,
    border: '1px solid #F1F1F1',
  },
  inputText: {
    fontSize: 16,
    borderRadius: 4,
    padding: 10,
  },
};

InviteSubscribersModal.propTypes = {
  onIncreasePrivateSubscribers: PropTypes.func,
  onEndInviteListeners: PropTypes.func,
};

InviteSubscribersModal.defaultProps = {
  onIncreasePrivateSubscribers: () => {},
  onEndInviteListeners: () => {},
};

export default InviteSubscribersModal;
